<div class="modal-dialog modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-body modal-body-scroll">
      <sa-terms-of-use></sa-terms-of-use>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="onAgree()">Agree</button>
      <button type="button" class="btn btn-danger" (click)="onDisagree()">Disagree</button>
    </div>
  </div>
</div>